import { render, staticRenderFns } from "./groupAgreedGoods.vue?vue&type=template&id=017d2e68&scoped=true"
import script from "./groupAgreedGoods.vue?vue&type=script&lang=js"
export * from "./groupAgreedGoods.vue?vue&type=script&lang=js"
import style0 from "./groupAgreedGoods.vue?vue&type=style&index=0&id=017d2e68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017d2e68",
  null
  
)

export default component.exports